import { Box, BoxExportedProps } from "@adfenix/alexandria";
import { ReactNode } from "react";
import styled from "styled-components";

type PageContainerProps = {
  $centered?: boolean;
  $topPadding: 48 | 24 | false;
};

export const PageContainer = styled(Box)<PageContainerProps>`
  height: 100%;
  flex-grow: 1;
  overflow-y: auto;

  ${({ $topPadding }) =>
    $topPadding && `padding-top: ${$topPadding}px !important`};

  margin: ${({ $centered: centered }) => (centered ? "0 auto" : "0 0 0 320px")};

  @media (max-width: 767.98px) {
    margin-left: 0;
    ${({ $topPadding }) => $topPadding && "padding-top: 96px !important"}

    overflow-x: hidden;
  }
`;

type PageProps = {
  children: ReactNode;
  fullWidth?: boolean;
  centered?: boolean;
  header?: string | ReactNode;

  /**
   * 48 is the default while 24 is used for a few pages like results.
   * False can be passed if you want to use the padding on the box and not override anything.
   *
   * Use false if you want to disable the larger padding on mobile which is used to ensure the content
   * is below the mobile top bar.
   */
  topPadding?: 48 | 24 | false;
} & BoxExportedProps;

const Page = ({
  children,
  header,
  centered,
  fullWidth,
  topPadding = 48,
  ...rest
}: PageProps) => {
  return (
    <PageContainer
      $centered={centered}
      $topPadding={topPadding}
      p={["l", "xl3", "xl5"]}
      {...rest}
    >
      <Box style={{ maxWidth: fullWidth ? undefined : "980px" }}>
        {header ? <Box>{header}</Box> : <></>}
        <Box style={{ height: "100%" }}>{children}</Box>
      </Box>
    </PageContainer>
  );
};

export default Page;
